

import React from "react";
import "./WhatWeDo.css";
import devIcon from "../../assets/Development.png";
import hrIcon from "../../assets/HRCon.png";
import internshipIcon from "../../assets/InternPro.png";
import marketingIcon from "../../assets/DigitalMarketing.png";

const services = [
  {
    icon: devIcon,
    title: "Web & Mobile App Development",
    description: "From idea to launch, we build what clicks.",
  },
  {
    icon: hrIcon,
    title: "HR Consulting",
    description: "Your HR partner for smarter people management",
  },
  {
    icon: internshipIcon,
    title: "Internship Programs",
    description: "Real skills, real projects, no boring textbooks.",
  },
  {
    icon: marketingIcon,
    title: "Digital Marketing",
    description: "Strategies that get you seen - and remembered.",
  },
];

const WhatWeDoSection = () => (
  <section className="wwd-section">
    <h2 className="wwd-section-title">What We Do</h2>
    <p className="wwd-section-subtitle">
      At WebBunny Development, we empower brands through technology, people & digital growth.
    </p>
    <div className="wwd-services-grid">
      {services.map((service) => (
        <article key={service.title} className="wwd-service-card" tabIndex="0">
          <img
            src={service.icon}
            alt={`${service.title} icon`}
            className="wwd-service-icon"
          />
          <h3 className="wwd-service-title">{service.title}</h3>
          <p className="wwd-service-description">{service.description}</p>
        </article>
      ))}
    </div>
  </section>
);

export default React.memo(WhatWeDoSection);
